import { ViewCancelForm } from '@actions/novaOrdemActions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { CancelarFolha } from '@services/api/api.folha';
import { Form, Input, Modal } from 'antd';

type FormData = {
  motivo: string;
};

function FolhaCancelarModal() {
  const dispatch = useAppDispatch();
  const { cancelForm } = useAppSelector((state) => state.novaOrdem);
  const cancelarFolha = CancelarFolha();
  const [form] = Form.useForm<FormData>();
  const handleSubmit = (values: FormData) => {
    if (cancelForm.replace) {
      cancelarFolha.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: true, cod: cancelForm.cod });
    } else cancelarFolha.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: false, cod: cancelForm.cod });
  };
  return (
    <Modal
      open={cancelForm.visible}
      title="Razão do cancelamento/substituição"
      onCancel={() => {
        dispatch(ViewCancelForm({ id: null, view: false, replace: false, cod: null }));
      }}
      okButtonProps={{ loading: cancelarFolha.isLoading }}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item rules={[{ required: true, message: 'Campo obrigatório' }]} name="motivo">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default FolhaCancelarModal;
